/**
 * @Desc: 订单记录静态数据
 * @Date: 2021-11-03 09:55
 * @Last Modified by: p_yufangyin
 */
import { orderStatusOptions } from '@/constants/goods/';

export const STATUS_EUNM = {
  waiting: {
    text: '待发货',
    className: 'waiting',
  },
  delivered: {
    text: '已发货',
    className: 'delivered',
  },
  processing: {
    text: '订单处理中',
    className: '_processing',
  },
  cancelled: {
    text: '订单已取消',
    className: 'cancelled',
  },
  fail: {
    text: '交易失败',
    className: 'fail',
  },
};

export const FIELD_SOURCE = [
  {
    name: 'uuid',
    label: '订单号',
    type: 'input',
    placeholder: '请输入内容',
    span: 8,
  },
  {
    name: 'user',
    label: '用户',
    type: 'input',
    placeholder: '用户姓名、用户id',
    span: 8,
  },
  {
    name: 'status',
    label: '订单状态',
    type: 'select',
    options: orderStatusOptions,
    span: 8,
    props: {
      allowClear: true,
    },
  },
  {
    name: 'action_time',
    label: '下单时间',
    type: 'range-picker',
    span: 8,
  },
  {
    name: 'goods',
    label: '兑换商品',
    type: 'input',
    placeholder: '商品名称、商品id',
    span: 8,
  },
  {
    name: 'express_number',
    label: '快递单号',
    type: 'input',
    placeholder: '请输入内容',
    span: 8,
  },
  {
    name: 'supplier',
    label: '供应商',
    type: 'select',
    options: [],
    span: 8,
    props: {
      allowClear: true,
    },
  },
  {
    name: 'line',
    label: '产线',
    type: 'select',
    slot: 'line_code',
    span: 8,
    props: {
      allowClear: true,
    },
  },
];

export const COLUMNS = [
  {
    title: '订单号',
    dataIndex: 'uuid',
    fixed: 'left',
    width: 180,
  },
  {
    title: '用户id',
    dataIndex: 'creator_uid',
  },
  {
    title: '用户姓名',
    dataIndex: 'creator',
  },
  {
    title: '下单时间',
    dataIndex: 'create_time',
    width: 200,
  },
  {
    title: '兑换商品',
    dataIndex: 'goods_info',
    scopedSlots: { customRender: 'goods_info' },
    ellipsis: true,
    width: 280,
  },
  {
    title: '数量',
    dataIndex: 'count',
  },
  {
    title: '供应商',
    dataIndex: 'supplier_name',
  },
  {
    title: '所属产线',
    dataIndex: 'line_name',
  },
  {
    title: '联系信息',
    dataIndex: 'address_info',
    scopedSlots: { customRender: 'address_info' },
    ellipsis: true,
    width: 300,
  },
  {
    title: '快递单号',
    dataIndex: 'express_number',
    width: 180,
  },
  {
    title: '订单状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
    width: 130,
  },
  {
    title: '用户备注',
    dataIndex: 'user_comment',
  },
  {
    title: '操作人',
    dataIndex: 'operator',
  },
  {
    title: '操作时间',
    dataIndex: 'update_time',
    width: 200,
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
    fixed: 'right',
  },
];
